export interface FieldLabel {
    text?: string;
    tooltip?: string;
    mergeTooltip?: boolean;
    tooltipClass?: string;
}
